import type { DialogProps } from "../misc/DialogProps";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { Identifier } from "react-admin";
import { useState } from "react";
import { TheoryExamSimulationResultsView } from "./TheoryExamSimulationResultsDialog/TheoryExamSimulationResultsView";
import { TheoryExamSimulationResultView } from "./TheoryExamSimulationResultsDialog/TheoryExamSimulationResultView";
import { BackButton } from "../buttons/BackButton";
import { TheoryQuestion } from "../model/TheoryQuestion";
import { GivenAnswer } from "../providers/theoryExamSimulationResultsProvider";
import { TheoryQuestionView } from "./TheoryExamSimulationResultsDialog/TheoryQuestionView";

interface ResultsState {
  view: "results";
}

interface ResultDetailsState {
  view: "resultDetails";
  simulationId: Identifier;
}

interface TheoryQuestionState {
  view: "theoryQuestion";
  question: TheoryQuestion;
  givenAnswer: GivenAnswer;
  /** for back navigation */
  simulationId: Identifier;
}

type DialogState = ResultsState | ResultDetailsState | TheoryQuestionState;

export function TheoryExamSimulationResultsDialog(props: DialogProps) {
  const { onClose } = props;
  const [dialogState, setDialogState] = useState<DialogState>({ view: "results" });

  return (
    <Dialog {...props} maxWidth={dialogState.view === "theoryQuestion" ? "lg" : "md"} fullWidth>
      <DialogTitle>
        <_DialogTitle dialogState={dialogState} setDialogState={setDialogState} />
      </DialogTitle>
      <DialogCloseButton onClick={onClose} />
      <DialogContent sx={{ maxHeight: "600px", overflowY: "auto" }}>
        {dialogState.view === "results" && (
          <TheoryExamSimulationResultsView
            onClick={(simulationId) => {
              setDialogState({ view: "resultDetails", simulationId });
            }}
          />
        )}
        {dialogState.view === "resultDetails" && (
          <TheoryExamSimulationResultView
            simulationId={dialogState.simulationId}
            onClick={(question, givenAnswer, simulationId) => {
              setDialogState({ view: "theoryQuestion", question, givenAnswer, simulationId });
            }}
          />
        )}
        {dialogState.view === "theoryQuestion" && (
          <TheoryQuestionView question={dialogState.question} givenAnswer={dialogState.givenAnswer} />
        )}
      </DialogContent>
    </Dialog>
  );
}

function _DialogTitle({
  dialogState,
  setDialogState,
}: {
  dialogState: DialogState;
  setDialogState: (view: DialogState) => void;
}) {
  switch (dialogState.view) {
    case "resultDetails":
      return <BackButton onClick={() => setDialogState({ view: "results" })}>Zurück</BackButton>;
    case "theoryQuestion":
      return (
        <BackButton onClick={() => setDialogState({ view: "resultDetails", simulationId: dialogState.simulationId })}>
          Zurück
        </BackButton>
      );
    default:
      return "Prüfungssimulationen";
  }
}
